import { SOURCE } from "@/constants";

export const MIN_REACH_BY_CHANNEL_TYPE_SOURCES = [
  SOURCE.TWITTER,
  SOURCE.FACEBOOK,
  SOURCE.PODCAST,
  SOURCE.MANUAL,
  SOURCE.INSTAGRAM,
  SOURCE.TIKTOK,
  SOURCE.YOUTUBE,
  SOURCE.WEB_TV,
  SOURCE.TV,
  SOURCE.RADIO,
  SOURCE.NEWS,
];

export type MinReachByChannelTypeSource =
  (typeof MIN_REACH_BY_CHANNEL_TYPE_SOURCES)[number];

export type MinReachByChannelTypeValues = {
  [SOURCE.TWITTER]: number;
  [SOURCE.FACEBOOK]: number;
  [SOURCE.PODCAST]: number;
  [SOURCE.MANUAL]: number;
  [SOURCE.INSTAGRAM]: number;
  [SOURCE.TIKTOK]: number;
  [SOURCE.YOUTUBE]: number;
  [SOURCE.WEB_TV]: number;
  [SOURCE.TV]: number;
  [SOURCE.RADIO]: number;
  [SOURCE.NEWS]: number;

  has_custom_values: boolean;
};

const MIN_REACH_BY_CHANNEL_TYPE_DEFAULT_VALUES: MinReachByChannelTypeValues = {
  [SOURCE.YOUTUBE]: 1000,
  [SOURCE.INSTAGRAM]: 400,
  [SOURCE.TWITTER]: 0,
  [SOURCE.FACEBOOK]: 0,
  [SOURCE.PODCAST]: 0,
  [SOURCE.MANUAL]: 0,
  [SOURCE.TIKTOK]: 0,
  [SOURCE.WEB_TV]: 0,
  [SOURCE.TV]: 0,
  [SOURCE.RADIO]: 0,
  [SOURCE.NEWS]: 0,

  has_custom_values: false,
};

export const getMinReachByChannelTypeDefaultValues = (
  minReachByChannelTypeSources: MinReachByChannelTypeSource[]
): MinReachByChannelTypeValues => {
  const defaultValues: Partial<MinReachByChannelTypeValues> = {
    has_custom_values: false,
  };

  minReachByChannelTypeSources.forEach((source) => {
    defaultValues[source] = MIN_REACH_BY_CHANNEL_TYPE_DEFAULT_VALUES[source];
  });

  return defaultValues as MinReachByChannelTypeValues;
};
